export const GERMAN_LOCALE = { language: "de", country: "DE" };
export const GERMAN_LOCALE_STRING = "de_DE";
